module.exports = __webpack_public_path__ + "assets/img/img33.c49bfd9f.png";